/**
 * @fileoverview Arquivo responsável por definir as traduções em espanhol da aplicação.
 */

const messages = {
  es: {
    translations: {
      selectLanguage: "Seleccione un idioma",
      onboarding: {
        title: "Configuración de su cuenta",
        subtitle: "Complete los pasos y empiece a operar",
        minimize: "Minimizar",
        requiredTag: "Obligatoria",
        of: "de",
        stepsDone: "pasos completados",
        groups: {
          required: "Obligatorias",
          optional: "Opcionales (recomendadas)",
        },
        cta: {
          iniciar: "Iniciar",
          continuar: "Continuar",
          revisar: "Revisar",
          retomar: "Retomar",
          pular: "Omitir",
        },
        tour: {
          gotit: "Entendido",
        },
        celebration: {
          taskDone: "¡Bien! Un paso más completado 🎉",
          aha: "¡Felicidades! Su IA fue creada con éxito",
          allDone: "¡Excelente! Completó los pasos principales del onboarding 🏆",
        },
        trial: {
          prefix: "Período de prueba:",
          daysLeft: "días restantes",
          dayLeft: "día restante",
          lastDay: "último día",
        },
        blocked: {
          title: "Cuenta pausada",
          titleCancelled: "Cuenta cancelada",
          desc: "Su período de prueba terminó y no identificamos un pago confirmado. Regularice para seguir usando Sttelar Chat.",
          descCancelled: "Esta cuenta fue cancelada. Póngase en contacto para reactivarla.",
          payCta: "Regularizar pago",
          updateCard: "Actualizar forma de pago",
          contact: "Póngase en contacto con soporte para regularizar.",
          pausedAdminContact: "Hable con el administrador de su cuenta para regularizar el pago y reactivar el acceso.",
        },
        checkout: {
          title: "Elige tu plan",
          desc: "Tu prueba gratis terminó. Selecciona un plan para seguir usando Sttelar Chat.",
          basic: "Basic",
          pro: "Pro",
          basicDesc: "Atención humana organizada",
          proDesc: "Atención con IA + humanos",
          aiSeatNote: "La IA cuenta como 1 usuario",
          aiSeatTooltip: "En el plan Pro, la IA se cobra como 1 usuario del plan. Ej.: 2 agentes humanos + IA = 3 usuarios facturables.",
          features: {
            basic: [
              "Flujos de Chatbot",
              "Informes detallados",
              "Respuestas rápidas ilimitadas",
              "CRM integrado a WhatsApp",
              "Centralización de la atención"
            ],
            pro: [
              "Todo del Plan Basic",
              "Atención 24/7 con IA",
              "IA personalizada para tu negocio"
            ]
          },
          monthly: "Mensual",
          annual: "Anual",
          annualSave: "−16%",
          users: "Usuarios",
          minNote: "Cobro mínimo de 3 usuarios",
          addon: "Chat Interno",
          addonHint: "Comunicación interna entre equipos (por usuario)",
          billable: "usuarios facturables",
          perMonth: "/mes",
          cta: "Continuar al pago",
          cardTitle: "Pago",
          cardDesc: "Cobro recurrente en la tarjeta de crédito.",
          cardNumber: "Número de tarjeta",
          cardHolder: "Nombre en la tarjeta",
          expMonth: "Mes",
          expYear: "Año",
          expiry: "Vencimiento",
          acceptedBrands: "Tarjetas aceptadas",
          cvv: "CVV",
          pay: "Pagar",
          processing: "Procesando...",
          fillCard: "Complete todos los datos de la tarjeta.",
          payError: "No se pudo completar el pago",
          successTitle: "¡Pago recibido!",
          confirmingTitle: "Confirmando el pago...",
          successDesc: "Tu suscripción fue creada. Tu cuenta se liberará en instantes.",
          releasingDesc: "Estamos confirmando tu pago. Tu cuenta será liberada en instantes.",
          stillReleasingDesc: "Recibimos tu pago. La liberación puede tardar unos instantes más — ya puedes acceder.",
          releasedTitle: "¡Cuenta liberada!",
          releasedDesc: "¡Todo listo! Ya tienes acceso completo a Sttelar Chat.",
          access: "Acceder ahora",
          closeNow: "Cerrar",
          paymentMethod: "Forma de pago",
          payCard: "Tarjeta de crédito",
          payPix: "PIX",
          pixOnlyAnnualShort: "Solo en el plan anual",
          pixTitle: "Paga con PIX",
          pixDesc: "Escanea el QR o copia el código. La activación es automática tras el pago.",
          pixCopy: "Copiar código",
          pixCopied: "¡Copiado!",
          pixWaiting: "Esperando el pago...",
          back: "Volver",
          annualCharge: "Cobrado por año",
          secureNote: "Procesado de forma segura por Pagar.me. No almacenamos los datos de tu tarjeta.",
          stepPlan: "Plan",
          stepBilling: "Facturación",
          stepPayment: "Pago",
          next: "Continuar",
          toBilling: "Continuar a facturación",
          toPayment: "Continuar al pago",
          billingTitle: "Datos de facturación",
          billingDesc: "Usados para emisión y seguridad del pago.",
          document: "CPF / CNPJ",
          phone: "Teléfono",
          cep: "Código postal",
          street: "Dirección",
          number: "Número",
          complement: "Complemento",
          neighborhood: "Barrio",
          city: "Ciudad",
          state: "Estado",
          optional: "Opcional",
          fillBilling: "Complete los datos de facturación obligatorios.",
          supportWhatsappMessage: "Estoy en la etapa de elección del plan de Sttelar Chat y tengo una duda",
          supportTooltip: "Consultar al soporte de Sttelar por WhatsApp",
          logoutTooltip: "Cerrar sesión",
          logout: "Salir",
          documentPlaceholder: "CPF o CNPJ",
          numberPlaceholder: "N.º",
          streetPlaceholder: "Calle y número",
          statePlaceholder: "Estado",
          cardHolderPreview: "NOMBRE EN LA TARJETA",
          cardHolderPlaceholder: "NOMBRE COMO EN LA TARJETA",
          pixQrAlt: "Código QR PIX",
          aiSeatSuffix: " (+IA)",
        },
        upgrade: {
          loadError: "No se pudieron cargar los datos del plan.",
          confirmError: "No se pudo completar la mejora",
          titleInternal: "Agregar Chat Interno",
          titleAttendance: "Agregar usuarios",
          descInternal: "Aumenta la cantidad de usuarios de Chat Interno de tu plan.",
          descAttendance: "Aumenta la cantidad de usuarios de tu plan.",
          descNextCharge: " El nuevo importe se aplicará en el próximo cobro.",
          close: "Cerrar",
          successTitle: "¡Asientos actualizados!",
          successInternal: "Ahora tienes {{count}} asientos de Chat Interno.",
          successAttendance: "Ahora tienes {{count}} usuarios en el plan.",
          planUnavailable: "Plan no disponible.",
          planRowInternal: "Plan {{tier}} · {{ciclo}} · hoy {{count}} Chat Interno",
          planRowAttendance: "Plan {{tier}} · {{ciclo}} · hoy {{count}} {{usersWord}}",
          cycleAnnual: "Anual",
          cycleMonthly: "Mensual",
          userSingular: "usuario",
          userPlural: "usuarios",
          newTotalInternal: "Nuevo total de Chat Interno",
          newTotalAttendance: "Nuevo total de usuarios",
          minHint: "Mínimo {{min}} (1 más que el actual)",
          perMonth: "por mes",
          billedAnnually: " · cobrado anualmente",
          breakInternal: "{{addon}} Chat Interno · {{seats}} facturables{{ai}}",
          breakAttendance: "{{seats}} asientos facturables{{ai}}",
          aiSuffix: " (+IA)",
          processing: "Procesando...",
          confirm: "Confirmar mejora",
          footnote: "El importe adicional se cobra a partir del próximo ciclo. Puedes reducirlo más tarde contactando con el soporte.",
        },
        changeCard: {
          notConfigured: "Pago no configurado (falta la clave pública).",
          fillAllFields: "Completa todos los datos de la tarjeta.",
          saveError: "No se pudo cambiar la tarjeta",
          title: "Cambiar tarjeta",
          desc: "La nueva tarjeta se usará en los próximos cobros de la suscripción.",
          close: "Cerrar",
          successTitle: "¡Tarjeta actualizada!",
          numberLabel: "Número de la tarjeta",
          holderLabel: "Nombre impreso",
          holderPlaceholder: "Como aparece en la tarjeta",
          expiryLabel: "Vencimiento",
          expiryPlaceholder: "MM/AA",
          cvvLabel: "CVV",
          processing: "Procesando...",
          save: "Guardar tarjeta",
          secureNote: "Tus datos van directos y cifrados a Pagar.me — no pasan por nuestros servidores.",
        },
        tasks: {
          createAi: { label: "Crear la IA de la empresa", desc: "Cree su agente inteligente y pruébelo al instante" },
          connectWhatsapp: { label: "Conectar WhatsApp", desc: "Conecte un número para empezar a atender" },
          transferRule: { label: "Regla de transferencia a humano", desc: "Defina cuándo la IA pasa a un agente" },
          registerUsers: { label: "Registrar usuarios", desc: "Agregue otros usuarios que atenderán por Sttelar Chat" },
          businessHours: { label: "Horario de atención", desc: "Configure los horarios de su operación" },
          quickMessage: { label: "Mensaje rápido", desc: "Cree respuestas listas para agilizar" },
          sectorsQueues: { label: "Crear sectores", desc: "Organice la atención por colas/sectores" },
          tags: { label: "Configurar etiquetas", desc: "Clasifique sus atenciones con etiquetas" },
          crmBoards: { label: "Configurar boards (CRM)", desc: "Gestione leads y tareas en el Kanban" },
          academy: { label: "Finalizar capacitaciones", desc: "Aprenda a usar la plataforma en la Academy" },
        },
        aha: {
          title: "Crear la IA de la empresa",
          subtitle: "Complete los campos y cree su agente inteligente",
          create: "Crear mi IA",
          cancel: "Cancelar",
          done: "Finalizar",
          requiredWarning: "Indique al menos el nombre de la IA y el segmento.",
          successTitle: "¡Su IA está lista!",
          successSubtitle: "Pruebe una pregunta ahora mismo",
          successMessage: "¡Listo! Su IA fue creada y ya puede responder a sus primeros clientes con base en la información registrada.",
          fallbackNote: "Para probar la IA aquí, configure una integración OpenAI en Integraciones. La IA ya fue creada y estará lista cuando se registre la clave.",
          fields: {
            nomeIA: { label: "Nombre de la IA", placeholder: "Ej.: Sttela" },
            segmento: { label: "Segmento de la empresa", placeholder: "Ej.: Clínica odontológica" },
            tom: { label: "Tono de atención", placeholder: "Elija o describa el tono" },
            produtosServicos: { label: "Principales productos o servicios", placeholder: "¿Qué ofrecen?" },
            duvidasFrequentes: { label: "Dudas frecuentes", placeholder: "¿Qué preguntan más los clientes?" },
            regrasAtendimento: { label: "Reglas básicas de atención", placeholder: "Ej.: siempre confirmar nombre y teléfono" },
            infosImportantes: { label: "Información que la IA debe saber", placeholder: "Horarios, dirección, políticas..." },
            situacoesTransferencia: { label: "Cuándo transferir a un humano", placeholder: "Ej.: reclamos o solicitudes complejas" },
          },
        },
      },
      signup: {
        title: "Regístrate",
        toasts: {
          success: "¡Usuario creado con éxito! ¡Inicia sesión!!!",
          fail: "Error al crear usuario. Verifica los datos ingresados.",
        },
        form: {
          name: "Nombre de la empresa",
          email: "Correo electrónico",
          phone: "Teléfono con (código de área)",
          plan: "Plan",
          password: "Contraseña",
        },
        formErrors: {
          name: {
            required: "El nombre de la empresa es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          password: {
            short: "Contraseña demasiado corta",
            long: "Contraseña demasiado larga",
          },
          email: {
            required: "El correo electrónico es obligatorio",
            invalid: "Correo electrónico inválido",
          },
        },
        buttons: {
          submit: "Registrar",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
        plan: {
          attendant: "Asistente",
          whatsapp: "WhatsApp",
          queues: "Colas",
        },
      },
      login: {
        title: "Iniciar sesión",
        form: {
          email: "Correo electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Iniciar sesión",
          submitting: "Iniciando sesión...",
          register: "¡Regístrate ahora mismo!",
        },
        errors: {
          emailRequired: "El correo es obligatorio",
          emailInvalid: "Correo inválido",
          passwordRequired: "La contraseña es obligatoria",
        },
        capsLockOn: "Bloq Mayús activado",
      },
      mfa: {
        setup: {
          title: "Configurar autenticación en dos pasos",
          scanQr: "Escanea el QR con Google Authenticator, Duo Mobile u otra app compatible.",
          manualSecret: "¿No puedes escanear? Usa este código manualmente:",
          next: "Siguiente",
          back: "Volver",
          confirmOtp: "Introduce el código de 6 dígitos de la app:",
          confirm: "Confirmar",
          backupTitle: "Códigos de recuperación",
          backupHint: "Guárdalos en un lugar seguro. Cada código es de un solo uso y reemplaza la app si pierdes el teléfono.",
          copyAll: "Copiar todo",
          download: "Descargar .txt",
          savedAck: "He guardado mis códigos de forma segura",
          oneTimeWarning: "Estos códigos se mostrarán una sola vez.",
          finish: "Finalizar",
          cancel: "Cancelar",
          copied: "Códigos copiados",
        },
        login: {
          title: "Verificación en dos pasos",
          otpLabel: "Código de la app autenticadora",
          otpHint: "Introduce el código de 6 dígitos de tu app.",
          backupLabel: "Código de recuperación",
          backupHint: "Usa uno de los códigos de recuperación que guardaste.",
          verify: "Verificar",
          useBackup: "Código de recuperación",
          useOtp: "Usar app autenticadora",
          backToPassword: "Volver",
        },
        policy: {
          title: "Política MFA de la empresa",
          modeOff: "Desactivado",
          modeOptional: "Opcional",
          modeRequired: "Obligatorio",
          gracePeriod: "Plazo para configurar (días)",
          saved: "Política actualizada",
          description: "Define si los usuarios de la empresa deben configurar la autenticación en dos pasos.",
        },
        profile: {
          menuItem: "Autenticación en dos pasos",
          statusEnabled: "Activa desde {{date}}",
          statusDisabled: "No configurada",
          enable: "Activar",
          disable: "Desactivar",
          disableConfirm: "Confirma con el código actual para desactivar MFA",
          adminReset: "Resetear MFA del usuario",
          adminResetConfirm: "¿Seguro? El usuario tendrá que reconfigurar la app en el próximo login.",
          adminResetDone: "MFA reseteado",
          enabledDesc: "Tu cuenta está protegida: en cada inicio de sesión necesitas el código de la app autenticadora.",
          disabledDesc: "Activa la autenticación en dos pasos para reforzar la seguridad de tu cuenta. Necesitarás una app como Google Authenticator o Duo Mobile.",
        },
        banner: {
          title: "Tu empresa requiere autenticación en dos pasos.",
          subtitle: "Configúrala en los próximos {{days}} día(s) para seguir accediendo.",
          cta: "Configurar ahora",
        },
        errors: {
          invalidOtp: "Código inválido o expirado",
          ticketExpired: "La sesión de verificación expiró. Vuelve a iniciar sesión.",
          backupUsed: "Código de recuperación ya usado",
        },
      },
      resetPassword: {
        title: "Restablecer Contraseña",
        toasts: {
          emailSent: "¡Correo enviado con éxito!",
          emailNotFound: "¡Correo electrónico no encontrado!",
          passwordUpdated: "¡Contraseña actualizada con éxito!",
        },
        formErrors: {
          email: {
            required: "El correo electrónico es obligatorio",
            invalid: "Correo electrónico inválido",
          },
          newPassword: {
            required: "La nueva contraseña es obligatoria",
            matches:
                "Tu contraseña debe tener al menos 8 caracteres, incluyendo una letra mayúscula, una minúscula y un número.",
          },
          confirmPassword: {
            required: "La confirmación de contraseña es obligatoria",
            matches: "Las contraseñas no coinciden",
          },
        },
        form: {
          email: "Correo electrónico",
          verificationCode: "Código de verificación",
          newPassword: "Nueva contraseña",
          confirmPassword: "Confirmar nueva contraseña",
        },
        buttons: {
          submitEmail: "Enviar correo",
          submitPassword: "Restablecer contraseña",
          back: "¿No tienes una cuenta? ¡Regístrate!",
        },
      },
      dashboard: {
        toasts: {
          selectFilterError: "Parametrice el filtro",
              userChartError: "Error al obtener información de la conversación",
              dateChartError: "Error al obtener información de la conversación",
        },
        filters: {
          initialDate: "Fecha Inicial",
              finalDate: "Fecha Final",
              filterType: {
            title: "Tipo de Filtro",
                options: {
              perDate: "Filtro por Fecha",
                  perPeriod: "Filtro por Período",
            },
            helper: "Seleccione el tipo de filtro deseado",
          },
        },
        periodSelect: {
          title: "Período",
              options: {
            none: "Ninguno seleccionado",
                last3: "Últimos 3 días",
                last7: "Últimos 7 días",
                last15: "Últimos 15 días",
                last30: "Últimos 30 días",
                last60: "Últimos 60 días",
                last90: "Últimos 90 días",
          },
          helper: "Seleccione el período deseado",
        },
        counters: {
          inTalk: "En conversación",
              waiting: "En espera",
              finished: "Finalizados",
              newContacts: "Nuevos contactos",
              averageTalkTime: "T.M. de Conversación",
              averageWaitTime: "T.M. de Espera",
        },
        buttons: {
          filter: "Filtrar",
        },
        onlineTable: {
          ratingLabel: "1 - Insatisfecho, 2 - Satisfecho, 3 - Muy Satisfecho",
              name: "Nombre",
              ratings: "Evaluaciones",
              avgSupportTime: "T.M. de Atención",
              status: "Estado (Actual)",
        },
        charts: {
          user: {
            label: "Gráfico de Conversaciones",
                title: "Total de Conversaciones por Usuarios",
                start: "Inicio",
                end: "Fin",
                filter: "Filtrar",
          },
          date: {
            label: "Gráfico de Conversaciones",
                title: "Total",
                start: "Inicio",
                end: "Fin",
                filter: "Filtrar",
          },
        },
      },
      dashboardGeral: {
        title: "Panel del Grupo",
        subtitle: "Vista consolidada del grupo {{groupName}}",
        accountsCount: "{{count}} cuentas",
        cards: {
          active: "Atenciones Activas",
          pending: "Pendientes",
          noResponse: "Sin Respuesta +10min",
          noResponseRate: "Tasa sin respuesta",
          avgPerAttendant: "Promedio/Agente",
          art: "ART del Grupo",
        },
        table: {
          title: "Rendimiento por Cuenta",
          headers: {
            account: "Cuenta",
            active: "Activos",
            pending: "Pendientes",
            noResponse: "Sin Resp +10min",
            art: "ART",
            attendants: "Agentes",
          },
        },
        states: {
          loading: "Cargando panel del grupo...",
          empty: "No se encontraron cuentas en este grupo",
          error: "Error al cargar el panel. ¿Reintentar?",
        },
      },
      plans: {
        toasts: {
          errorList: "No fue posible cargar la lista de registros",
          errorOperation: "No fue posible realizar la operación",
          error: "No fue posible realizar la operación. Verifique si ya existe un plan con el mismo nombre o si los campos fueron completados correctamente",
          success: "¡Operación realizada con éxito!",
        },
        confirm: {
          title: "Eliminación de Registro",
          message: "¿Realmente desea eliminar el registro?",
        },
        buttons: {
          newCategory: "Nueva Categoría",
          newPlan: "Nuevo Plan",
        },
        modal: {
          editPlan: "Editar Plan",
          newPlan: "Nuevo Plan",
          newCategory: "Nueva Categoría",
          categoryName: "Nombre de la Categoría",
          categoryPlaceholder: "Ej: Premium, Enterprise, Starter",
          basicInfo: "Información Básica",
          emptyCategory: "Esta categoría está vacía. Haga clic en \"Nuevo Plan\" para agregar.",
        },
        labels: {
          plans: "Planes",
          plan: "plan",
          plansPlural: "planes",
        },
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          value: "Valor",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "CRM",
          integrations: "Integraciones",
          campaigns: "Campañas",
          schedules: "Programaciones",
          leads: "CRM",
          enabled: "Habilitadas",
          disabled: "Deshabilitadas",
          clear: "Cancelar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "$",
        },
      },
      externalLeads: {
        title: "CRM",
        refresh: "Actualizar",
        stats: {
          total: "Total de Leads",
          unviewed: "Nuevos",
          pending: "Pendiente",
          completed: "Completados",
        },
        filters: {
          searchPlaceholder: "Buscar por nombre, teléfono, ID u orden de servicio...",
          status: "Estado",
          all: "Todos",
          sortBy: "Ordenar por",
          newestFirst: "Más recientes",
          oldestFirst: "Más antiguos",
        },
        card: {
          new: "Nuevo",
          notInformed: "No informado",
          attachments: "anexo(s)",
          serviceOrderPlaceholder: "Orden de Servicio",
          saveServiceOrder: "Guardar O.S.",
          noChanges: "Sin cambios",
          viewDetails: "Ver detalles",
          delete: "Eliminar",
          startConversation: "Iniciar conversación en WhatsApp",
        },
        modal: {
          clientInfo: "Información del Cliente",
          name: "Nombre",
          phone: "Teléfono",
          email: "E-mail",
          cpf: "Número de ID",
          address: "Dirección",
          serviceOrder: "Orden de Servicio",
          attachments: "Anexos",
          customFields: "Campos Adicionales",
          changeStatus: "Cambiar Estado",
          receivedAt: "Recibido en:",
          viewedAt: "Visto en:",
          close: "Cerrar",
        },
        confirmDelete: {
          title: "Eliminar Lead",
          message: "¿Está seguro que desea eliminar este lead? Esta acción no se puede deshacer.",
        },
        empty: {
          title: "Ningún lead encontrado",
          description: "Los leads recibidos vía webhook aparecerán aquí",
        },
        loading: "Cargando...",
        toasts: {
          newLead: "Nuevo lead recibido:",
          deleted: "Lead eliminado con éxito",
          statusUpdated: "¡Estado actualizado!",
          serviceOrderSaved: "¡Orden de Servicio guardada!",
        },
        defaultStatus: "Pendiente",
      },
      kanban: {
        title: "CRM Kanban",
        toasts: {
          removed: "¡Etiqueta eliminada del ticket!",
          added: "¡Etiqueta agregada con éxito!",
          refreshed: "¡Datos actualizados!",
          errorLoadingTags: "Error al cargar etiquetas",
          errorLoadingTickets: "Error al cargar tickets",
          errorMoving: "Error al mover tarjeta",
        },
        open: "Abierto",
        seeTicket: "Ver Ticket",
        tickets: "tickets",
        columns: "columnas",
        refresh: "Actualizar",
        searchPlaceholder: "Buscar por nombre o número...",
        allQueues: "Todas las colas",
        loading: "Cargando tickets...",
        noMessage: "Sin mensaje",
        unknownContact: "Contacto desconocido",
      },
      companies: {
        title: "Registrar Empresa",
        buttons: {
          newGroup: "Nuevo Grupo",
          newCompany: "Nueva Empresa",
        },
        modal: {
          editCompany: "Editar Empresa",
          newCompany: "Nueva Empresa",
          newGroup: "Nuevo Grupo",
          groupName: "Nombre del Grupo",
          groupPlaceholder: "Ej: Cliente XYZ",
        },
        labels: {
          companies: "Empresas",
          company: "empresa",
          companiesPlural: "empresas",
        },
        tooltips: {
          addUser: "Agregar nuevo usuario",
          editUser: "Editar usuario existente",
          editCompany: "Editar empresa",
          deleteCompany: "Eliminar empresa",
        },
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión realizado con éxito!",
        },
        token: "Token",
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted: "¡Conexión con WhatsApp eliminada con éxito!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? Esta acción no puede ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Está seguro? Necesitará leer el código QR nuevamente.",
        },
        buttons: {
          add: "Agregar Conexión",
          disconnect: "desconectar",
          tryAgain: "Intentar nuevamente",
          qrcode: "CÓDIGO QR",
          newQr: "Nuevo CÓDIGO QR",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesión de WhatsApp",
            content: "Asegúrese de que su teléfono esté conectado a internet e intente nuevamente, o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content: "Haga clic en el botón 'CÓDIGO QR' y lea el código QR con su teléfono para iniciar la sesión",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content: "Asegúrese de que su teléfono esté conectado a internet y WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agregar WhatsApp",
          edit: "Editar WhatsApp",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          expiresTicket: {
            number: "Ingrese un número válido",
            integer: "Use solo números enteros",
            min: "Mínimo 0 (desactivado)",
            max: "Máximo 43200 minutos (30 días)",
          },
          expiresInactiveMessage: {
            max: "Mensaje demasiado largo (máx 1000 caracteres)",
          },
          greetingAcceptedMessage: {
            max: "Mensaje demasiado largo (máx 1000 caracteres)",
          },
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario laboral",
        },
        form: {
          name: "Nombre",
          default: "Predeterminado",
          sendIdQueue: "Cola",
          timeSendQueue: "Redirigir a cola en X minutos",
          queueRedirection: "Redirección de Cola",
          outOfHoursMessage: "Mensaje fuera de horario",
          queueRedirectionDesc:
              "Seleccione una cola para redirigir los contactos que no tienen cola asignada",
          prompt: "Prompt",
          queue: "Cola de Transferencia",
          timeToTransfer: "Transferir después de x (minutos)",
          metaInfo: "Ingrese las credenciales de su aplicación de Meta para usar la API oficial de WhatsApp Cloud.",
          metaAccessToken: "Access Token",
          metaPhoneNumberId: "Phone Number ID",
          metaBusinessAccountId: "Business Account ID (opcional)",
          metaAppId: "App ID (opcional)",
          metaAppSecret: "App Secret",
          metaWebhookToken: "Webhook Verify Token",
          metaApiVersion: "Versión de la Graph API",
          autoCloseTitle: "Cierre automático",
          autoCloseHelp: "Cierra la conversación cuando el cliente no responde al agente tras el tiempo configurado. El mensaje de abajo se envía antes del cierre.",
          expiresTicket: "Tiempo de inactividad",
          expiresTicketUnit: "minutos",
          expiresInactiveMessage: "Mensaje de cierre",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          greetingAcceptedTitle: "Saludo al aceptar ticket",
          greetingAcceptedMessage: "Mensaje al aceptar la atención",
          greetingAcceptedMessagePlaceholder: "Ej.: {{ms}} *{{name}}*, mi nombre es *{{userName}}* y continuaré con tu atención.",
          greetingAcceptedMessageHelp: "Se envía cuando el agente acepta un ticket pendiente. Déjalo vacío para usar el texto predeterminado.",
          sendTransferQueueMessageTitle: "Mensaje al transferir de cola",
          sendTransferUserMessageTitle: "Mensaje al transferir de agente",
          sendTransferQueueAndUserMessageTitle: "Mensaje al transferir cola y agente",
          integration: "Integración"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado con éxito.",
      },
      qrCodeModal: {
        title: "Utilice su WhatsApp:",
        steps: {
          one: "1 - Abra WhatsApp en su teléfono",
          two: {
            partOne: "2 - Toque en Más opciones en Android",
            partTwo: "o en Configuración",
            partThree: "en iPhone",
          },
          three:
              "3 - Toque en Dispositivos vinculados y luego en Vincular un dispositivo",
          four: "4 - Apunte su teléfono a esta pantalla para capturar el código QR",
        },
        waiting: "Esperando lectura del código QR",
        tabs: {
          qr: "Código QR",
          pairing: "Código de vinculación",
        },
        pairing: {
          title: "Vincular con número",
          phoneLabel: "Número con código de país y área",
          phonePlaceholder: "Ej: 5491155551234",
          generate: "Generar código",
          generating: "Generando...",
          instructions: "En WhatsApp del teléfono: Dispositivos vinculados → Vincular con número → ingrese el código abajo.",
          copy: "Copiar",
          copied: "¡Copiado!",
          invalidPhone: "Ingrese un número válido con código de país.",
        },
      },
      qrCode: {
        message: "Lea el código QR para iniciar la sesión",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto eliminado con éxito!",
          deletedAll: "¡Todos los contactos eliminados con éxito!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          deleteAllTitle: "Eliminar Todos",
          importTitle: "Importar contactos",
          deleteMessage:
              "¿Está seguro que desea eliminar este contacto? Todos los tickets relacionados se perderán.",
          deleteAllMessage:
              "¿Está seguro que desea eliminar todos los contactos? Todos los tickets relacionados se perderán.",
          importMessage: "¿Desea importar todos los contactos del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contactos",
          delete: "Eliminar Todos los Contactos",
          startConversation: "Iniciar conversación en WhatsApp",
          edit: "Editar contacto",
          deleteSingle: "Eliminar contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Acciones",
        },
      },
      contactImportModal: {
        title: "Planilla de contactos",
        labels: {
          import: "Importar contactos",
          result: "resultados",
          added: "Agregados",
          savedContact: "Contacto guardado",
          errors: "Errores",
        },
        buttons: {
          download: "Descargar planilla modelo",
          import: "Importar contactos",
          background: "Continuar en segundo plano",
          close: "Cerrar",
        },
        progress: {
          importing: "Importando {{processed}} de {{total}} contactos...",
          success: "{{count}} importados con éxito",
          errors: "{{count}} con errores",
          complete: "Importación completada",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración probada con éxito!",
          addSuccess: "Integración agregada con éxito.",
          editSuccess: "Integración editada con éxito.",
        },
      },
      sideMenu: {
        name: "Menú Lateral Inicial",
        note: "Si está habilitado, el menú lateral iniciará cerrado",
        options: {
          enabled: "Abierto",
          disabled: "Cerrado",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          model: "Modelo",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes en el Historial",
        },
        formErrors: {
          name: {
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
            required: "El nombre es obligatorio",
          },
          prompt: {
            short: "Prompt demasiado corto",
            required: "Describa el entrenamiento para la Inteligencia Artificial",
          },
          modal: {
            required: "Informe el modelo deseado para el Prompt",
          },
          maxTokens: {
            required: "Informe el número máximo de tokens en la respuesta",
          },
          temperature: {
            required: "Informe la temperatura",
          },
          apikey: {
            required: "Informe la API Key",
          },
          queueId: {
            required: "Informe la cola",
          },
          maxMessages: {
            required: "Informe el número máximo de mensajes en el historial",
          },
        },
        success: "¡Prompt guardado con éxito!",
        setor: "Informe el sector",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "Máximo Tokens Respuesta",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no puede ser revertida!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Datos del contacto",
          basicInfo: "Información básica",
          complementaryInfo: "Datos complementarios",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de WhatsApp",
          email: "Email",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          whatsapp: "Conexión Origen: ",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          phone: {
            short: "Número demasiado corto",
            long: "Número demasiado largo",
          },
          email: {
            invalid: "Email inválido",
          },
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado con éxito.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          nameShort: "Nombre corto",
          nameLong: "Nombre largo",
          nameRequired: "El nombre es obligatorio",
          color: "Color",
          colorShort: "Color corto",
          colorLong: "Color largo",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusión",
          outOfHoursMessage: "Mensaje fuera de horario",
          ratingMessage: "Mensaje de evaluación",
          token: "Token",
          orderQueue: "Orden de la cola (Bot)",
          integrationId: "Integración",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        toasts: {
          success: "Cola guardada con éxito.",
          info: "Haga clic en guardar para registrar los cambios",
        },
        tabs: {
          queueData: "Datos de la cola",
          attendanceTime: "Horarios de Atención",
        },
      },
      userModal: {
        loading: "Cargando datos del usuario...",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Email",
          cpf: "CPF",
          password: "Contraseña",
          profile: "Perfil",
          jobRole: "Cargo",
          noJobRole: "Sin cargo",
          operationalType: "Tipo operativo",
          attendant: "Atendente",
          supervisor: "Supervisor",
          whatsapp: "Conexión Predeterminada",
          noWhatsapp: "Sin conexión",
          queues: "Colas de Usuario",
          profileImage: "Cambiar Foto",
          uploadPhoto: "Cargar Foto",
          allTicket: "Ticket Sin Cola [Invisible]",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Deshabilitado",
          accessScope: "Alcance de Acceso *",
          accessScopeFull: "Completo (Atención + Interno)",
          accessScopeAttendance: "Solo Atención (Tickets, WhatsApp)",
          accessScopeInternal: "Solo Interno (Chat, CRM)",
          internalLockedNotice: "El Chat Interno no está incluido en tu plan. Realiza un upgrade en Ajustes → Facturación para habilitarlo.",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre demasiado corto",
            long: "Nombre demasiado largo",
          },
          password: {
            short: "Contraseña demasiado corta",
            long: "Contraseña demasiado larga",
          },
          email: {
            required: "El email es obligatorio",
            invalid: "Email inválido",
          },
        },
        labels: {
          liberations: "Liberaciones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado con éxito.",
      },
      scheduleModal: {
        title: {
          add: "Nueva Programación",
          edit: "Editar Programación",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programación guardada con éxito.",
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada con éxito.",
      },
      chat: {
        toasts: {
          fillTitle: "Por favor, complete el título de la conversación.",
          fillUser: "Por favor, seleccione al menos un usuario.",
        },
        modal: {
          title: "Conversación",
          titleField: "Título",
        },
        confirm: {
          title: "Eliminar Conversación",
          message: "Esta acción no puede ser revertida, ¿confirmar?",
        },
        chats: "Chats",
        messages: "Mensajes",
        noTicketMessage: "Seleccione un ticket para comenzar a chatear.",
        buttons: {
          close: "Cerrar",
          save: "Guardar",
          new: "Nueva",
          newChat: "Nuevo",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTRE Y SUELTE ARCHIVOS EN EL CAMPO DE ABAJO",
          titleFileList: "Lista de archivo(s)",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Colas",
        noQueue: "Sin cola",
      },
      tickets: {
        handledByAi: "Atendido por IA: {{name}}",
        toasts: {
          deleted: "La atención que estabas atendiendo fue eliminada.",
          unauthorized: "Acceso no permitido",
        },
        filters: {
          user: "Filtrar por usuarios",
          tags: "Filtrar por etiquetas",
          connection: "Filtrar por conexión",
          queues: "Filtrar por colas",
          emptyQueueWarning: "Seleccione al menos una cola (o 'Sin cola') para aplicar el filtro.",
          tagsPlaceholder: "Filtrar por etiquetas",
          tagsPopoverTitle: "Etiquetas",
          tagsSearchPlaceholder: "Buscar",
          noTagsOption: "Sin etiquetas",
          noTagsFound: "Ninguna etiqueta encontrada",
          singleSelected: "seleccionado",
          multipleSelected: "seleccionados",
          showingAll: "Mostrando todos los elementos",
          clear: "Limpiar",
          loadingTags: "Cargando etiquetas...",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Abiertos" },
          groups: { title: "Grupos" },
          closed: { title: "Resueltos" },
          search: { title: "Búsqueda" },
        },
        search: {
          placeholder: "Buscar atención y mensajes",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldUserLabel: "Agente",
        fieldQueueLabel: "Transferir a cola",
        fieldQueuePlaceholder: "Seleccione una cola",
        userPlaceholder: "Seleccione un agente",
        userPopoverTitle: "Agentes",
        userSearchPlaceholder: "Buscar agentes",
        clearUserOption: "Limpiar selección",
        noUsersFound: "Ningún agente encontrado",
        showingAllUsers: "Mostrando todos los agentes",
        noOptions: "Ningún usuario encontrado con ese nombre",
        noSelection: "Seleccione un agente o una cola para transferir.",
        queuePopoverTitle: "Colas",
        queueSearchPlaceholder: "Buscar colas",
        noQueueOption: "Sin cola",
        noQueuesFound: "Ninguna cola encontrada",
        singleSelected: "elemento seleccionado",
        showingAll: "Mostrando todas las colas",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "En espera",
        pendingHeaderTab: "Pendiente",
        assignedHeader: "En atención",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage:
            "Ninguna atención encontrada con ese estado o término buscado",
        buttons: {
          accept: "Aceptar",
          closed: "Finalizar",
          reopen: "Reabrir",
        },
      },
      ticketsListItem: {
        tooltip: {
          chatbot: "Chatbot",
          peek: "Espiar Conversación",
          unreplied: "Sin respuesta hace más de 10 minutos",
        },
        noQueue: "SIN COLA",
        viewLocation: "Ver ubicación en el mapa",
      },
      ticketAdvanced: {
        selectTicket: "Seleccionar Ticket",
        ticketNav: "Ticket",
        attendanceNav: "Atenciones",
      },
      newTicketModal: {
        title: "Elegir un contacto",
        searchPlaceholder: "Buscar por nombre o telefono",
        tagsPlaceholder: "Etiquetas",
        tagsPopoverTitle: "Etiquetas",
        tagsSearchPlaceholder: "Buscar",
        showingAll: "Mostrando todos los elementos",
        singleSelected: "elemento seleccionado",
        multipleSelected: "elementos seleccionados",
        clear: "Limpiar",
        noTagsOption: "Sin etiquetas",
        noTagsFound: "No se encontraron etiquetas",
        ticketTitle: "Elija un ticket",
        createTicket: "Crear ticket",
        existingContactPlaceholder: "Busque un contacto existente",
        contactSearchHint: "Escriba al menos 3 caracteres para buscar un contacto",
        queuePlaceholder: "Seleccione una cola",
        allQueuesOption: "Todas las colas",
        queuePopoverTitle: "Colas",
        queueSearchPlaceholder: "Buscar colas",
        noQueueOption: "Crear sin cola",
        noQueuesFound: "No se encontro ninguna cola",
        connectionPlaceholder: "Seleccione una conexion",
        allConnectionsOption: "Todas las conexiones",
        connectionPopoverTitle: "Conexiones",
        loadingConnections: "Cargando conexiones...",
        noConnectionsAvailable: "No hay conexiones disponibles",
        newContact: "Nuevo contacto",
        emptyState: "No se encontro ningun contacto",
        emptyTicketsState: "No se encontro ningun ticket",
        loadingTags: "Cargando etiquetas...",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      locationPreview: {
        button: "Visualizar",
        openInMaps: "Abrir en Maps",
        showMap: "Ver en el mapa",
        hideMap: "Ocultar mapa",
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          dashboardGeral: "Panel del Grupo",
          connections: "Conexiones",
          tickets: "Atenciones",
          quickMessages: "Respuestas Rápidas",
          tasks: "Tareas",
          contacts: "Contactos",
          queues: "Colas & Chatbot",
          tags: "Etiquetas",
          academy: "Capacitación",
          manageAcademy: "Gestionar Capacitación",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuraciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programaciones",
          campaigns: "Campañas",
          flows: "Flujos",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          files: "Lista de archivos",
          prompts: "IA",
          queueIntegration: "Integraciones",
          metaTemplates: "Plantillas Meta",
          integrations: "Integraciones",
        },
        appBar: {
          refresh: "Recargar página",
          notRegister: "Sin notificaciones",
          language: "Idioma",
          jobRole: "Cargo",
          noJobRole: "Sin cargo",
          appearance: "Apariencia",
          notificationVolume: "Sonido de Notificaciones",
          greeting: {
            hello: "Hola",
            welcome: "Bienvenido a",
            active: "Activo hasta",
          },
          user: {
            profile: "Perfil",
            logout: "Salir",
          },
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Lenguaje",
          lastUpdate: "Última actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
              "¿Está seguro? ¡Esta acción no puede ser revertida! y será eliminada de las colas y conexiones vinculadas",
        },
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "¡Lista eliminada con éxito!",
          deletedAll: "¡Todas las listas fueron eliminadas con éxito!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "¿Está seguro que desea eliminar esta lista?",
          deleteAllMessage: "¿Está seguro que desea eliminar todas las listas?",
        },
      },
      messagesAPI: {
        title: "API",
        labels: {
          doc: "Documentación para envío de mensajes",
          method: "Métodos de Envío",
          textMessage: "Mensaje de Texto",
          mediaMessage: "Mensaje Multimedia",
          instructions: "Instrucciones",
          observations: "Observaciones importantes",
          before1: "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes.",
          before2: "Para realizar el registro acceda al menú 'Conexiones', haga clic en el botón editar de la conexión e inserte el token en el campo correspondiente.",
          numberDescription: "El número para envío no debe tener máscara o caracteres especiales y debe estar compuesto por:",
          countryCode: "Código del País",
          number: "Número",
          textMessage2: "1. Mensajes de Texto",
          textMessageInstructions: "A continuación la lista de información necesaria para enviar mensajes de texto:",
          method2: "Método",
          e: "y",
          tests: "Prueba de Envío",
          mediaMessage2: "2. Mensajes Multimedia",
        },
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        toasts: {
          unauthorized: "¡Esta empresa no tiene permiso para acceder a esta página! Le estamos redirigiendo.",
          success: "¡Mensaje enviado con éxito!",
        },
        buttons: {
          send: "Enviar",
        },
      },
      notifications: {
        noTickets: "Ninguna notificación.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin adjunto",
        confirmationModal: {
          deleteTitle: "Eliminación",
          deleteMessage: "¡Esta acción es irreversible! ¿Desea continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "¡Atajo agregado con éxito!",
          deleted: "¡Atajo eliminado con éxito!",
        },
        validation: {
          shortcodeRequired: "Ingrese el atajo de la respuesta rápida.",
          messageRequired: "Ingrese el mensaje de la respuesta rápida.",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
        },
      },
      leadSettings: {
        tabs: {
          apiTokens: "Tokens de API",
          leadStatuses: "Estados de los Leads",
        },
        tokens: {
          newToken: "Nuevo Token",
          webhookTitle: "URL del Webhook para N8N",
          webhookHint: "Envía el header:",
          copyUrl: "Copiar URL",
          urlCopied: "¡URL del webhook copiada!",
          emptyTitle: "Ningún token creado",
          emptyDescription: "Crea un token de API para integrar con N8N u otras plataformas",
          createdAt: "Creado en:",
          deleteTitle: "Eliminar Token de API",
          deleteMessage: "¿Estás seguro de que deseas eliminar el token \"{name}\"? Esta acción no se puede deshacer y todas las integraciones que usan este token dejarán de funcionar.",
          deleted: "Token eliminado con éxito",
        },
        statuses: {
          newStatus: "Nuevo Estado",
          emptyTitle: "Ningún estado creado",
          emptyDescription: "Crea estados personalizados para organizar tus leads",
          default: "Predeterminado",
          pending: "Pendiente",
          completed: "Completado",
          order: "Orden",
          deleteTitle: "Eliminar Estado",
          deleteMessage: "¿Estás seguro de que deseas eliminar el estado \"{name}\"? Los leads con este estado serán movidos al estado predeterminado.",
          deleted: "Estado eliminado con éxito",
        },
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lista",
        },
        dialog: {
          name: "Nombre",
          nameShort: "Nombre corto",
          nameLong: "Nombre largo",
          nameRequired: "El nombre es obligatorio",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          deleted: "Registro eliminado",
          success: "Operación realizada con éxito",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Buscar",
        report: {
          title: "Informe de",
          title2: "Campaña",
          of: "de",
          validContacts: "Contactos válidos",
          delivered: "Entregados",
          connection: "Conexión",
          contactList: "Lista de Contactos",
          schedule: "Programación",
          conclusion: "Conclusión",
        },
        config: {
          interval: "Intervalos",
          randomInterval: "Intervalo Aleatorio de Envío",
          biggerInterval: "Intervalo Mayor Después de",
          greaterInterval: "Intervalo de Envío Mayor",
          noInterval: "Sin Intervalo",
          second: "segundo",
          seconds: "segundos",
          notDefined: "No definido",
          addVariable: "Agregar Variable",
          save: "Guardar Configuración",
          shortcut: "Atajo",
          content: "Contenido",
          close: "Cerrar",
          add: "Agregar",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listas de Contactos",
        },
        status: {
          inactive: "Inactiva",
          programmed: "Programada",
          inProgress: "En progreso",
          canceled: "Cancelada",
          finished: "Finalizada",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de Contactos",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Completada",
          confirmation: "Confirmación",
          actions: "Acciones",
          notDefined: "No definida",
          notDefined2: "No definido",
          notScheduled: "Sin programación",
          notConcluded: "No concluida",
          stopCampaign: "Detener Campaña",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Lectura",
          form: {
            name: "Nombre",
            nameShort: "Nombre corto",
            nameLong: "Nombre largo",
            helper: "Utilice variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
            nameRequired: "El nombre es obligatorio",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmación",
            contactList: "Lista de Contactos",
            tagList: "Lista de Etiquetas",
            fileList: "Lista de Archivos",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          configSaved: "Configuración guardada",
          success: "Operación realizada con éxito",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro eliminado",
        },
      },
      announcements: {
        active: "Activo",
        inactive: "Inactivo",
        title: "Informativos",
        searchPlaceholder: "Buscar",
        high: "Alta",
        medium: "Media",
        low: "Baja",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Edición de Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Solo Lectura",
          form: {
            priority: "Prioridad",
            required: "Campo obligatorio",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        toasts: {
          success: "Operación realizada con éxito",
          deleted: "Registro eliminado",
          info: "¡Esta empresa no tiene permiso para acceder a esta página! Le estamos redirigiendo.",
        },
      },
      campaignsConfig: {
        title: "Configuración de Campañas",
      },
      queues: {
        title: "Colas & Chatbot",
        table: {
          id: "ID",
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          actions: "Acciones",
          orderQueue: "Ordenación de la cola (bot)",
        },
        buttons: {
          add: "Agregar cola",
        },
        emptyState: "No se encontraron colas",
        toasts: {
          success: "Cola eliminada con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Está seguro? ¡Esta acción no puede ser revertida! Las atenciones de esta cola seguirán existiendo, pero no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Colas",
      },
      users: {
        title: "Usuarios",
        table: {
          id: "ID",
          name: "Nombre",
          email: "Email",
          profile: "Perfil",
          actions: "Acciones",
          admin: "Admin",
          user: "Usuario",
        },
        buttons: {
          add: "Agregar usuario",
        },
        seatLimitReached: "Alcanzaste el límite de usuarios de tu plan. Realiza un upgrade en Ajustes → Facturación para agregar más.",
        emptyState: "No se encontraron usuarios",
        toasts: {
          created: "Usuario creado con éxito.",
          deleted: "Usuario eliminado con éxito.",
          updated: "Usuario actualizado con éxito.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Todos los datos del usuario se perderán. Las atenciones abiertas de este usuario serán movidas a la cola.",
        },
      },
      todolist: {
        input: "Nueva tarea",
        buttons: {
          add: "Agregar",
          save: "Guardar",
        },
      },
      helps: {
        title: "Centro de Ayuda",
      },
      schedules: {
        title: "Programaciones",
        confirmationModal: {
          deleteTitle: "¿Está seguro que desea eliminar esta Programación?",
          deleteMessage: "Esta acción no puede ser revertida.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Programación",
          sentAt: "Fecha de Envío",
          status: "Estado",
          actions: "Acciones",
        },
        messages: {
          date: "Fecha",
          time: "Hora",
          event: "Evento",
          allDay: "Todo el Día",
          week: "Semana",
          work_week: "Programaciones",
          day: "Día",
          month: "Mes",
          previous: "Anterior",
          next: "Siguiente",
          yesterday: "Ayer",
          tomorrow: "Mañana",
          today: "Hoy",
          agenda: "Agenda",
          noEventsInRange: "No hay programaciones en el período.",
          showMore: "más",
        },
        buttons: {
          add: "Nueva Programación",
        },
        toasts: {
          deleted: "Programación eliminada con éxito.",
        },
      },
      tags: {
        title: "Etiquetas",
        confirmationModal: {
          deleteTitle: "¿Está seguro que desea eliminar esta Etiqueta?",
          deleteMessage: "Esta acción no puede ser revertida.",
          deleteAllMessage: "¿Está seguro que desea eliminar todas las Etiquetas?",
          deleteAllTitle: "Eliminar Todas",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Registros Etiquetados",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Etiqueta",
          deleteAll: "Eliminar Todas",
        },
        toasts: {
          deletedAll: "¡Todas las Etiquetas eliminadas con éxito!",
          deleted: "Etiqueta eliminada con éxito.",
        },
      },
      settings: {
        schedulesUpdated: "Horarios actualizados con éxito.",
        success: "Configuración guardada con éxito.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          jobRoles: "Cargos",
          security: "Seguridad",
          schedules: "Horarios",
          companyData: "Datos de la Empresa",
          billing: "Facturación",
          companies: "Empresas",
          plans: "Planes",
          helps: "Ayuda",
        },
        companyData: {
          title: "Datos de la Empresa",
          subtitle: "Datos fiscales usados en la facturación y en documentos.",
          accountLabel: "Cuenta",
          razaoSocial: "Razón Social",
          nomeFantasia: "Nombre Comercial",
          cnpj: "CNPJ",
          phone: "Teléfono",
          email: "Correo electrónico",
          phRazaoSocial: "Ej: Comercio de Ropa S.A.",
          phNomeFantasia: "Ej: Tienda de Juan",
          phEmail: "finanzas@empresa.com",
          save: "Guardar",
          saved: "Datos actualizados con éxito.",
          primaryBadge: "Cuenta principal de facturación",
          primaryHint: "El CNPJ y el correo de esta cuenta alimentan la facturación (Pagar.me) y el pedido en el panel.",
          invalidCnpj: "CNPJ inválido. Verifique los dígitos.",
        },
        jobRoles: {
          title: "Cargos",
          emptyState: "Todavía no hay cargos creados para esta empresa.",
          modal: {
            add: "Nuevo cargo",
            edit: "Editar cargo",
          },
          form: {
            name: "Nombre del cargo",
          },
          buttons: {
            add: "Agregar cargo",
            cancel: "Cancelar",
            save: "Guardar",
          },
          toasts: {
            created: "Cargo creado con éxito.",
            updated: "Cargo actualizado con éxito.",
            deleted: "Cargo eliminado con éxito.",
          },
          confirmationModal: {
            deleteTitle: "Eliminar cargo",
            deleteMessage: "Los usuarios vinculados a este cargo pasarán automáticamente a Sin cargo.",
          },
        },
        options: {
          toasts: {
            success: "Operación actualizada con éxito.",
            webNotificationsUnsupported: "Este navegador no soporta notificaciones web.",
            webNotificationsPermissionDenied: "El permiso de notificación no fue concedido en el navegador.",
          },
          fields: {
            ratings: {
              title: "Evaluaciones",
              disabled: "Deshabilitadas",
              enabled: "Habilitadas",
            },
            expedientManager: {
              title: "Gestión de Horario Laboral",
              queue: "Cola",
              company: "Empresa",
            },
            ignoreMessages: {
              title: "Ignorar Mensajes de Grupos",
            },
            acceptCall: {
              title: "Aceptar Llamada",
              disabled: "No aceptar",
              enabled: "Aceptar",
            },
            chatbotType: {
              title: "Tipo Chatbot",
              text: "Texto",
            },
            sendGreetingMessageOneQueues: {
              title: "Enviar saludo cuando haya solo 1 cola",
            },
            quickMessagesScope: {
              title: "Respuestas Rápidas",
              description: "Define si las respuestas rápidas se comparten por usuario o empresa",
              user: "Por Usuario",
              company: "Por Empresa",
            },
            noResponseBusinessHours: {
              title: "Filtro de Horario Comercial",
              description: "Filtrar el historial de sin respuesta solo para horarios comerciales configurados",
            },
            webNotifications: {
              title: "Notificaciones Web",
              description: "Mostrar notificaciones del navegador para nuevos mensajes de tickets",
            },
            internalChatNotifications: {
              title: "Notificaciones del Chat Interno",
              description: "Mostrar notificaciones del navegador para DMs y menciones en el Chat Interno",
            },
            enableAcademy: {
              title: "Área de Capacitación",
              description: "Mostrar la página de Capacitación (Academy) para esta empresa",
            },
            disabled: "Deshabilitado",
            active: "Activo",
            enabled: "Habilitado",
            artThresholds: {
              title: "ART — Tiempo de Respuesta",
              description: "Define los límites en minutos para clasificar el tiempo medio de respuesta (verde, amarillo, rojo).",
              yellowLabel: "Límite amarillo (min)",
              redLabel: "Límite rojo (min)",
              invalidRange: "Límite rojo debe ser mayor que el amarillo (1–1440).",
            },
          },
          updating: "Actualizando...",
          tabs: {
            integrations: "INTEGRACIONES",
          },
        },
        helps: {
          toasts: {
            errorList: "No fue posible cargar la lista de registros",
            errorOperation: "No fue posible realizar la operación",
            error: "No fue posible realizar la operación. Verifique si ya existe una ayuda con el mismo nombre o si los campos fueron completados correctamente",
            success: "¡Operación realizada con éxito!",
          },
          buttons: {
            clean: "Limpiar",
            delete: "Eliminar",
            save: "Guardar",
          },
          grid: {
            title: "Título",
            description: "Descripción",
            video: "Video",
          },
          confirmModal: {
            title: "Eliminación de Registro",
            confirm: "¿Desea realmente eliminar este registro?",
          },
        },
        company: {
          toasts: {
            errorList: "No fue posible cargar la lista de registros",
            errorOperation: "No fue posible realizar la operación",
            error: "No fue posible realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si los campos fueron completados correctamente",
            success: "¡Operación realizada con éxito!",
          },
          confirmModal: {
            title: "Eliminación de Registro",
            confirm: "¿Desea realmente eliminar este registro?",
          },
          form: {
            name: "Nombre",
            email: "Email",
            phone: "Teléfono",
            plan: "Plan",
            status: "Estado",
            yes: "Sí",
            no: "No",
            campanhas: "Campañas",
            enabled: "Habilitadas",
            disabled: "Deshabilitadas",
            createdAt: "Creada En",
          },
          buttons: {
            clear: "Limpiar",
            delete: "Eliminar",
            user: "Usuario",
            save: "Guardar",
          },
        },
        schedules: {
          form: {
            weekday: "Día de la Semana",
            initialHour: "Hora Inicial",
            finalHour: "Hora Final",
            save: "Guardar",
          },
        },
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Regresar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            download: "Descargar",
          },
        },
        lostCall: "Llamada de voz/video perdida a las",
        deletedMessage: "Este mensaje fue borrado por el contacto",
        edited: "Editado",
        audio: "Audio",
        location: "Ubicación",
        saudation: "¡Saluda a tu nuevo contacto!",
      },
      messagesInput: {
        placeholderOpen: "Escribe un mensaje",
        placeholderClosed: "Reabre o acepta este ticket para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción",
        },
        formErrors: {
          name: {
            required: "El nombre es obligatorio",
            short: "Nombre muy corto",
          },
          message: {
            required: "El mensaje es obligatorio",
          },
        },
        success: "¡Lista de archivos guardada con éxito!",
      },
      ticketOptionsMenu: {
        schedule: "Programación",
        delete: "Eliminar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Ingrese aquí la información que desea registrar",
        },
        confirmationModal: {
          title: "Eliminar el ticket",
          titleFrom: "del contacto ",
          message: "¡Atención! Todos los mensajes relacionados al ticket se perderán.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        retry: "Reenviar",
        retrying: "Reenviando...",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      templateModal: {
        title: "Seleccionar Plantilla",
        searchPlaceholder: "Buscar por nombre o contenido...",
        loading: "Cargando plantillas...",
        recents: "Recientes",
        favorites: "Favoritas",
        favorite: "Marcar como favorita",
        unfavorite: "Quitar de favoritas",
        all: "Todas",
        previewEmpty: "Selecciona una plantilla para ver la vista previa",
        sentToast: "¡Plantilla \"{name}\" enviada con éxito!",
        categories: {
          all: "Todas",
          marketing: "Marketing",
          utility: "Utilitario",
          auth: "Autenticación",
          other: "Otro",
        },
        empty: {
          title: "Ninguna plantilla encontrada",
          description: "Configura plantillas aprobadas en tu cuenta Meta for Developers para usar esta función.",
        },
        noResults: {
          title: "Sin resultados",
          description: "Prueba otra búsqueda o quita el filtro de categoría.",
        },
        hints: {
          navigate: "navegar",
          send: "enviar",
          close: "cerrar",
        },
        buttons: {
          cancel: "Cancelar",
          send: "Enviar plantilla",
          sending: "Enviando...",
        },
      },
      academy: {
        title: "Capacitación",
        empty: "No hay cursos disponibles por el momento.",
        lessons: "lecciones",
        progress: "completado",
        courseContent: "Contenido del curso",
        ofLessonsCompleted: "de {{total}} completadas",
        lessonTag: "LECCIÓN",
        back: "Volver",
        videoUnavailable: "Video no disponible",
        continueWatching: "Continuar viendo",
        courseCompleted: "Curso completado",
        markComplete: "Marcar como completada",
        unmarkComplete: "Desmarcar",
        toasts: {
          disabled: "El Área de Capacitación está desactivada.",
          noPermission: "No tienes permiso para acceder a esta área.",
        },
        manage: {
          title: "Gestionar Capacitación",
          draft: "Borrador",
          buttons: {
            cancel: "Cancelar",
            save: "Guardar",
            addCourse: "Nuevo curso",
            addModule: "Nuevo módulo",
          },
          validation: {
            titleRequired: "Ingresa un título (mín. 2 caracteres).",
            videoUrlRequired: "Ingresa la URL del video.",
          },
          toasts: {
            courseSaved: "Curso guardado.",
            moduleSaved: "Módulo guardado.",
            lessonSaved: "Lección guardada.",
            thumbnailRemoved: "Miniatura eliminada.",
          },
          confirm: {
            deleteCourse: "Eliminar curso",
            deleteModule: "Eliminar módulo",
            deleteLesson: "Eliminar lección",
            message: "Esta acción no se puede deshacer.",
          },
          courseModal: {
            addTitle: "Nuevo curso",
            editTitle: "Editar curso",
            title: "Título",
            description: "Descripción",
            published: "Publicado",
            thumbnail: "Miniatura (imagen)",
            removeThumbnail: "Eliminar",
          },
          moduleModal: {
            addTitle: "Nuevo módulo",
            editTitle: "Editar módulo",
            title: "Título",
          },
          lessonModal: {
            addTitle: "Nueva lección",
            editTitle: "Editar lección",
            title: "Título",
            description: "Descripción",
            videoUrl: "URL del video (YouTube o Vimeo)",
            currentVideo: "Video actual",
            keepHint: "deja la URL en blanco para mantener",
          },
        },
      },
      backendErrors: {
        ERR_ACADEMY_DISABLED: "El Área de Capacitación está desactivada para esta empresa.",
        ERR_ACADEMY_INVALID_VIDEO_URL: "URL de video inválida. Usa un enlace de YouTube o Vimeo.",
        ERR_ACADEMY_COURSE_NOT_FOUND: "Curso no encontrado.",
        ERR_ACADEMY_MODULE_NOT_FOUND: "Módulo no encontrado.",
        ERR_ACADEMY_LESSON_NOT_FOUND: "Lección no encontrada.",
        ERR_INTERNAL_SERVER_ERROR: "Ocurrió un error inesperado. Por favor, intente nuevamente más tarde",
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND: "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesión de WhatsApp no fue inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT: "No fue posible verificar el contacto de WhatsApp. Verifique la página de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No fue posible descargar el archivo multimedia de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Usuario o contraseña incorrectos",
        ERR_USER_DONT_EXISTS: "Usuario no encontrado. Verifique el email proporcionado.",
        ERR_SENDING_WAPP_MSG: "Error al enviar mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No fue posible eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor inicie sesión.",
        ERR_USER_CREATION_DISABLED: "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tiene permiso para acceder a este recurso.",
        ERR_CANNOT_REMOVE_ACTIVE_COMPANY: "No se puede eliminar la Cuenta activa del usuario. Defina otra Cuenta como principal primero.",
        ERR_COMPANY_NOT_ASSIGNED: "Esta Cuenta no está vinculada al usuario.",
        ERR_COMPANY_ALREADY_ASSIGNED: "Esta Cuenta ya está vinculada al usuario.",
        ERR_COMPANY_NOT_IN_GROUP: "La Cuenta debe pertenecer a la misma Empresa que el usuario.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con este ID.",
        ERR_TICKET_NO_CONNECTION: "Este ticket no tiene una conexión WhatsApp definida. Seleccione una conexión antes de resolver.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al buscar el mensaje en WhatsApp, tal vez sea muy antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
      internalChat: {
        jobRoleRequired: {
          title: "Seleccione su cargo",
          intro: "Para usar el Chat Interno, elija el cargo que mejor representa su función en la empresa. Aparecerá junto a su nombre en las conversaciones.",
          empty: "Ningún cargo registrado. Pida al administrador que registre cargos en Configuración → Cargos.",
          confirm: "Confirmar",
          saving: "Guardando...",
          toastSaved: "Cargo definido",
        },
      },
      billing: {
        status: {
          teste_gratis: "Período de prueba",
          pago_ativo: "Activo",
          aguarda_pagamento: "Esperando pago",
          aguarda_assinatura: "Esperando suscripción",
          pagamento_vencido: "Pago vencido",
          bloqueado: "Bloqueado",
          cancelado: "Cancelado",
          onboarding: "En configuración",
        },
        invoiceStatus: {
          paga: "Pagada",
          pendente: "Pendiente",
          falhou: "Falló",
          cancelada: "Cancelada",
        },
        cancelError: "No fue posible cancelar ahora. Inténtalo de nuevo.",
        loadError: "No fue posible cargar la información de facturación en este momento.",
        retry: "Intentar de nuevo",
        exempt: {
          title: "Cuenta de cortesía",
          desc: "Uso gratuito — esta cuenta está exenta de cobro.",
          badge: "Exento",
        },
        noOrder: "No se encontró ningún pedido de facturación para esta cuenta.",
        productFallback: "Sttelar Chat",
        cycleAnnual: "Anual",
        cycleMonthly: "Mensual",
        perCycleAnnual: "/mes · cobrado anualmente",
        perCycleMonthly: "/mes",
        userSingular: "usuario",
        userPlural: "usuarios",
        withInternalChat: " · + Chat Interno",
        amount: "Importe",
        trialEndsOn: "La prueba termina el",
        daySingular: "día",
        dayPlural: "días",
        nextCharge: "Próximo cobro",
        manageUsers: "Gestionar usuarios",
        manageInternalChat: "Gestionar Chat Interno",
        cancelNotice: "Suscripción cancelada — mantienes el acceso hasta <strong>{{date}}</strong>. No habrá nuevos cobros.",
        pixNotice: "Plan anual vía <strong>PIX</strong> · acceso hasta <strong>{{date}}</strong>. Renovación con un nuevo PIX al final del período.",
        cancelSubscription: "Cancelar suscripción",
        paymentMethodTitle: "Forma de pago",
        noCard: "Ninguna tarjeta registrada",
        changeCard: "Cambiar tarjeta",
        invoicesTitle: "Historial de facturas",
        noInvoices: "Aún no se ha emitido ninguna factura.",
        billingDataTitle: "Datos de facturación",
        name: "Nombre",
        email: "Correo electrónico",
        document: "CPF/CNPJ",
        phone: "Teléfono",
        address: "Dirección",
        zipPrefix: "C.P.",
        cancelDialogText: "Tu suscripción dejará de renovarse, pero <strong>mantienes el acceso hasta {{date}}</strong> (fin del período ya pagado). No habrá nuevos cobros.",
        cancelDialogProAi: " La IA del plan Pro permanece activa hasta entonces.",
        keepSubscription: "Mantener suscripción",
        cancelling: "Cancelando...",
      },
    }
  }
};

export { messages };
